export const CHALLENGE_DICE_NOTATION = '[D]';
